// extracted by mini-css-extract-plugin
export default {"OmnibarContainer":"omnibar-container-module__OmnibarContainer__BZu1RMV"};